import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Autumn/AdditionAndSubtraction/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionAndSubtraction',
  field: 'Number',
  weeks: [6, 10],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/1IntroducePartsAndWholes" */ './1IntroducePartsAndWholes'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/2PartWholeModel" */ './2PartWholeModel'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/3WriteNumberSentences" */ './3WriteNumberSentences'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/4FactFamiliesAdditionFacts" */ './4FactFamiliesAdditionFacts'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/5NumberBondsWithin10" */ './5NumberBondsWithin10'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/6SystematicNumberBondsWithin10" */ './6SystematicNumberBondsWithin10'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/7NumberBondsTo10" */ './7NumberBondsTo10'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/8AdditionAddTogether" */ './8AdditionAddTogether'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/9AdditionAddMore" */ './9AdditionAddMore'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/10AdditionProblems" */ './10AdditionProblems'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/11FindAPart" */ './11FindAPart'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/12SubtractionFindAPart" */ './12SubtractionFindAPart'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/13FactFamiliesTheEightFacts" */ './13FactFamiliesTheEightFacts'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/14SubtractionTakeAwayCrossOut" */ './14SubtractionTakeAwayCrossOut'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/15SubtractionTakeAway" */ './15SubtractionTakeAway'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/16SubtractionOnANumberLine" */ './16SubtractionOnANumberLine'
        )
    }),
    // Step 17
    newSmallStepContent({
      ...BlockModel.smallSteps[16],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/AdditionAndSubtraction/17AddOrSubtract1Or2" */ './17AddOrSubtract1Or2'
        )
    })
  ]
});
export default Block;
